import React, { useState } from "react";
import Layer from "../../assets/Images/layer.png";
import { motion } from "framer-motion";

function ServicesSection() {
  const options = [
    "Software Development",
    "Cybersecurity",
    "App Design",
    "Web Design",
  ];
  const [selectedIndex, setSelectedIndex] = useState(0);

  const gradientStart = selectedIndex * 42;

  return (
    <div className="relative flex items-center justify-center w-full h-screen mt-22">
      <div className="absolute top-48 left-36 bg-[#3B2E09] w-[248px] h-[688.552px] rotate-[39.237deg] rounded-[50%] blur-[150px]" />
      <div className="absolute top-2 right-52 bg-[#2C4146] w-[248px] h-[688.552px] rotate-[39.237deg] rounded-[50%] blur-[150px]" />

      <div className="z-10 flex max-w-5xl mx-auto gap-28">
        <div>
          <h1 className="text-[27px] font-medium font-Gilroy text-[#EAEAEA] mb-8 tracking-wide">
            What we offer
          </h1>

          <div className="flex space-x-7">
            <div className="relative ml-2 mt-2 w-[1.6px] h-[160px]">
              <div
                className="absolute inset-0"
                style={{
                  background: `linear-gradient(to bottom, 
              #C69100 ${gradientStart}px, 
              #3B2E09, transparent)`,
                }}
              />
              <motion.div
                className="absolute -left-[7px] w-[14.311px] h-[18.634px] bg-white rounded-full transform -translate-x-1/2"
                initial={{ y: 0 }}
                animate={{ y: selectedIndex * 42 }}
                transition={{ duration: 0.3 }}
              />
            </div>

            <div className="flex flex-col space-y-6 tracking-tight text-nav">
              {options.map((option, index) => (
                <div
                  key={index}
                  className={`cursor-pointer transition-colors duration-300 ${
                    selectedIndex === index
                      ? "text-white font-light"
                      : "text-gray-500"
                  }`}
                  onClick={() => setSelectedIndex(index)}
                >
                  {option}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="w-[696px]">
          <div className="flex items-center flex-shrink-0 p-px mb-5 overflow-hidden bg-gradient-to-b from-gray-500 via-transparent to-transparent rounded-xl">
            <div className="relative w-[696px] h-[248px] rounded-[calc(0.75rem-1px)] bg-black ">
              <motion.div
                animate={{
                  y: [40, 0, 40],
                }}
                transition={{
                  duration: 6,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute -top-[90%] -left-40 w-[400px] h-[400px] bg-[#C69100] rounded-full z-10 blur-[83px] mix-blend-plus-lighter flex-shrink-0"
              />
              <motion.div
                animate={{
                  y: [-20, 20, -20],
                }}
                transition={{
                  duration: 6,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute -top-1/3 -right-32 w-[400px] h-[400px] bg-[#26424A] rounded-full z-10 blur-[83px] mix-blend-plus-lighter flex-shrink-0"
              />
              <img
                src={Layer}
                className="w-full blur-[12px] mix-blend-lighten object-cover select-none flex-shrink-0"
                alt="Layer"
              />

              <div>
                <motion.div
                  animate={{
                    y: [30, -20, 30],
                  }}
                  transition={{
                    duration: 6,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                  className={`absolute top-10 left-14 h-32 w-32 text-nav flex items-center justify-center bg-gradient-to-bl from-[#D9D9D94A] to-[#E7E7E700]  text-gray-300 z-10 rounded-xl flex-shrink-0
                    ${selectedIndex === 0 ? "flex" : "hidden"}
                    `}
                >
                  Robust
                </motion.div>

                {selectedIndex === 0 && (
                  <>
                    <motion.div
                      animate={{
                        y: [-10, 10, -10],
                      }}
                      transition={{
                        duration: 6,
                        repeat: Infinity,
                        ease: "easeInOut",
                      }}
                      className="absolute -bottom-5 left-[30%] h-28 w-32 text-nav flex items-center justify-center bg-[#D9D9D908] text-gray-300 z-10 rounded-xl flex-shrink-0 overflow-hidden"
                    >
                      <div
                        className="absolute inset-0 rounded-xl"
                        style={{
                          background:
                            "linear-gradient(to bottom right, #C69100,transparent, transparent,transparent)",
                          zIndex: -1,
                          mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                          WebkitMask:
                            "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                          maskComposite: "exclude",
                          WebkitMaskComposite: "xor",
                          padding: "0.8px",
                        }}
                      />
                      <span>Secure</span>
                    </motion.div>

                    <motion.div
                      animate={{
                        y: [10, -10, 10],
                      }}
                      transition={{
                        duration: 6,
                        repeat: Infinity,
                        ease: "easeInOut",
                      }}
                      className="absolute -top-5 left-[45%] border-[#C69100] h-28 w-28 text-nav flex items-center justify-center bg-[#D9D9D908] text-gray-300 z-10 rounded-xl flex-shrink-0"
                    >
                      <div
                        className="absolute inset-0 rounded-xl"
                        style={{
                          background:
                            "linear-gradient(to right, #C691005C, transparent, transparent, #2CA1BE5C)",
                          zIndex: -1,
                          mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                          WebkitMask:
                            "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                          maskComposite: "exclude",
                          WebkitMaskComposite: "xor",
                          padding: "0.8px",
                        }}
                      />

                      <span>Fast</span>
                    </motion.div>
                  </>
                )}

                {selectedIndex === 1 && (
                  <motion.div
                    animate={{
                      y: [-10, 30, -10],
                    }}
                    transition={{
                      duration: 6,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                    className="absolute top-[10%] left-[38%] flex-shrink-0"
                  >
                    <div className="relative">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="170"
                        height="180"
                        viewBox="0 0 220 230"
                        fill="none"
                      >
                        <path
                          d="M110.532 229.363C110.453 229.398 110.386 229.428 110.33 229.453C110.205 229.398 110.022 229.316 109.785 229.209C109.295 228.988 108.573 228.66 107.644 228.229C105.788 227.368 103.108 226.099 99.8176 224.468C93.2355 221.205 84.2105 216.495 74.4392 210.706C54.8763 199.116 32.3976 183.244 20.4918 166.046C1.68945 138.885 -0.980051 97.4559 1.09145 62.7121C2.12614 45.358 4.34106 29.7066 6.29752 18.3933C7.27568 12.737 8.18906 8.16618 8.85767 5.01033C9.19197 3.43243 9.46507 2.20833 9.65447 1.37923C9.73444 1.02915 9.79949 0.749495 9.84791 0.543377L107.623 10.862L107.674 10.8675L107.726 10.8622L208.96 0.541156C209.012 0.748169 209.083 1.03113 209.17 1.38677C209.373 2.21585 209.666 3.43993 210.025 5.01781C210.745 8.17363 211.731 12.7444 212.796 18.4006C214.926 29.7138 217.373 45.365 218.64 62.7187C221.175 97.4628 218.968 138.889 200.168 166.046C188.262 183.244 165.783 199.116 146.22 210.706C136.449 216.495 127.424 221.205 120.842 224.468C117.551 226.099 114.871 227.368 113.015 228.229C112.087 228.66 111.365 228.988 110.875 229.209C110.744 229.268 110.629 229.32 110.532 229.363Z"
                          fill="#D9D9D9"
                          fillOpacity="0.05"
                        />
                        <path
                          d="M110.532 229.363C110.453 229.398 110.386 229.428 110.33 229.453C110.205 229.398 110.022 229.316 109.785 229.209C109.295 228.988 108.573 228.66 107.644 228.229C105.788 227.368 103.108 226.099 99.8176 224.468C93.2355 221.205 84.2105 216.495 74.4392 210.706C54.8763 199.116 32.3976 183.244 20.4918 166.046C1.68945 138.885 -0.980051 97.4559 1.09145 62.7121C2.12614 45.358 4.34106 29.7066 6.29752 18.3933C7.27568 12.737 8.18906 8.16618 8.85767 5.01033C9.19197 3.43243 9.46507 2.20833 9.65447 1.37923C9.73444 1.02915 9.79949 0.749495 9.84791 0.543377L107.623 10.862L107.674 10.8675L107.726 10.8622L208.96 0.541156C209.012 0.748169 209.083 1.03113 209.17 1.38677C209.373 2.21585 209.666 3.43993 210.025 5.01781C210.745 8.17363 211.731 12.7444 212.796 18.4006C214.926 29.7138 217.373 45.365 218.64 62.7187C221.175 97.4628 218.968 138.889 200.168 166.046C188.262 183.244 165.783 199.116 146.22 210.706C136.449 216.495 127.424 221.205 120.842 224.468C117.551 226.099 114.871 227.368 113.015 228.229C112.087 228.66 111.365 228.988 110.875 229.209C110.744 229.268 110.629 229.32 110.532 229.363Z"
                          stroke="url(#paint0_linear_319_63)"
                        />
                        <path
                          d="M110.532 229.363C110.453 229.398 110.386 229.428 110.33 229.453C110.205 229.398 110.022 229.316 109.785 229.209C109.295 228.988 108.573 228.66 107.644 228.229C105.788 227.368 103.108 226.099 99.8176 224.468C93.2355 221.205 84.2105 216.495 74.4392 210.706C54.8763 199.116 32.3976 183.244 20.4918 166.046C1.68945 138.885 -0.980051 97.4559 1.09145 62.7121C2.12614 45.358 4.34106 29.7066 6.29752 18.3933C7.27568 12.737 8.18906 8.16618 8.85767 5.01033C9.19197 3.43243 9.46507 2.20833 9.65447 1.37923C9.73444 1.02915 9.79949 0.749495 9.84791 0.543377L107.623 10.862L107.674 10.8675L107.726 10.8622L208.96 0.541156C209.012 0.748169 209.083 1.03113 209.17 1.38677C209.373 2.21585 209.666 3.43993 210.025 5.01781C210.745 8.17363 211.731 12.7444 212.796 18.4006C214.926 29.7138 217.373 45.365 218.64 62.7187C221.175 97.4628 218.968 138.889 200.168 166.046C188.262 183.244 165.783 199.116 146.22 210.706C136.449 216.495 127.424 221.205 120.842 224.468C117.551 226.099 114.871 227.368 113.015 228.229C112.087 228.66 111.365 228.988 110.875 229.209C110.744 229.268 110.629 229.32 110.532 229.363Z"
                          stroke="url(#paint1_linear_319_63)"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_319_63"
                            x1="-1.71735e-06"
                            y1="92.8846"
                            x2="63.5055"
                            y2="129.052"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FFBB00" />
                            <stop
                              offset="1"
                              stopColor="#666666"
                              stopOpacity="0"
                            />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_319_63"
                            x1="198"
                            y1="151.5"
                            x2="208.5"
                            y2="158.5"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#2CA1BE" stopOpacity="0" />
                            <stop
                              offset="1"
                              stopColor="#2CA1BE"
                              stopOpacity="0.28"
                            />
                          </linearGradient>
                        </defs>
                      </svg>

                      <div className="absolute inset-0 flex items-center justify-center tracking-wide text-gray-400 font-Gilroy">
                        <div className="text-2xl font-medium leading-none">
                          <div className="text-[10px]">Cyber</div>
                          <div>Security</div>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                )}

                {(selectedIndex === 2 || selectedIndex === 3) && (
                  <motion.div
                    animate={{
                      y: [-10, 30, -10],
                    }}
                    transition={{
                      duration: 6,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  >
                    <div
                      className={`absolute
                    
                     text-nav bg-[#D9D9D908] text-gray-300 z-10 flex-shrink-0 transition-all duration-700 rounded-2xl
                     flex items-center justify-center 

                     ${
                       selectedIndex === 2
                         ? "-bottom-20 left-[35%] py-[25px] px-[9px] "
                         : "-bottom-1 left-[29%] p-[6px]"
                     }
                     
                     `}
                    >
                      <div
                        className="absolute inset-0 rounded-2xl"
                        style={{
                          background:
                            "linear-gradient(to bottom right, #FFBB00, #31240000,  transparent, #2CA1BE)",
                          zIndex: -1,
                          mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                          WebkitMask:
                            "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                          maskComposite: "exclude",
                          WebkitMaskComposite: "xor",
                          padding: "0.8px",
                        }}
                      />

                      <div
                        className={`relative bg-[#D9D9D90A] rounded-xl flex justify-center items-center text-xl font-Gilroy text-gray-400 ${
                          selectedIndex === 2 ? " h-56 w-48 " : "h-44 w-72"
                        }`}
                      >
                        <span>
                          {selectedIndex === 2 ? "App" : "Web"} Design
                        </span>

                        <div
                          className="absolute inset-0 rounded-xl "
                          style={{
                            background:
                              "linear-gradient(to bottom right, #999999, #31240000,  transparent, #23778cd4)",
                            zIndex: -1,
                            mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                            WebkitMask:
                              "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                            maskComposite: "exclude",
                            WebkitMaskComposite: "xor",
                            padding: "0.8px",
                          }}
                        />
                      </div>
                    </div>
                  </motion.div>
                )}

                <motion.div
                  animate={{
                    y: selectedIndex === 0 ? [-10, 10, -10] : [30, -20, 30],
                  }}
                  transition={{
                    duration: 6,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                  className={`absolute
                    
                     border-[#C69100] text-nav flex items-center justify-center bg-[#D9D9D908] text-gray-300 z-10 flex-shrink-0 transition-all
                     ${
                       selectedIndex === 0
                         ? "-bottom-5 left-[53%] h-36 w-32 rounded-xl"
                         : "top-10 left-14 h-32 w-32 rounded-full"
                     }
                     
                     `}
                >
                  <div
                    className={`absolute inset-0 transition-all ${
                      selectedIndex === 0 ? "rounded-xl" : "rounded-full"
                    }`}
                    style={{
                      background:
                        selectedIndex === 0
                          ? "linear-gradient(to top left, #2CA1BE, transparent, transparent)"
                          : "linear-gradient(to bottom right, #FFBB00, #31240000,  transparent)",
                      zIndex: -1,
                      mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                      WebkitMask:
                        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                      maskComposite: "exclude",
                      WebkitMaskComposite: "xor",
                      padding: "0.8px",
                    }}
                  />

                  <span>Modern</span>
                </motion.div>

                <motion.div
                  animate={{
                    y: [30, -20, 30],
                  }}
                  transition={{
                    duration: 6,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                  className={`absolute top-10 right-14 h-32 w-32 text-nav flex items-center justify-center bg-[#D9D9D908] text-gray-300 z-10 
                    ${selectedIndex === 0 ? "rounded-xl" : "rounded-full"}
                    
                    `}
                >
                  <div
                    className={`absolute inset-0 transition-all ${
                      selectedIndex === 0 ? "rounded-xl" : "rounded-full"
                    }`}
                    style={{
                      background:
                        "linear-gradient(to bottom right,  transparent, transparent, #2CA1BE  )",
                      zIndex: -1,
                      mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                      WebkitMask:
                        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                      maskComposite: "exclude",
                      WebkitMaskComposite: "xor",
                      padding: "0.8px",
                    }}
                  />

                  <span>Scalable</span>
                </motion.div>

                {/**/}
              </div>
            </div>
          </div>

          <p className="mb-20 text-xs font-medium">
            eCyberNest delivers exceptional, quality products that go beyond
            expectations. Join hands with us and experience innovation like
            never before!
          </p>

          <div className="flex items-center justify-end text-nav">
            <div className="flex items-center p-px cursor-pointer bg-gradient-to-r from-gray-300 to-gray-600 rounded-3xl">
              <div className="text-gray-200 bg-black rounded-[calc(1.5rem-1px)] pl-6 pr-3 py-2">
                <div className="flex items-center space-x-3">
                  <span>Get started</span>
                  <div className="flex items-center justify-center w-6 h-6 text-xs font-semibold text-black bg-white rounded-full">
                    +
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServicesSection;
